import classNames from 'classnames';
import PropTypes from 'prop-types';

const Banner = function Banner(props) {
  const {
    corner,
    text,
    text2,
    purple,
  } = props;

  if (corner) {
    return (
      <div className="z-[100] w-full h-full absolute top-0 left-0 bg-transparent pointer-events-none">
        <div className={classNames(
          'absolute w-80 -rotate-45 top-4 -left-32 opacity-70 py-0.5 font-bold text-center text-white px-24',
          {
            'bg-pxBanner': !purple,
            'bg-pxBannerAlt': purple,
          },
        )}
        >
          {/* <div className="font-bold bg-pxBanner/80 text-center text-white px-24"> */}
          {text}
          {(text2)
            ? (
                <>
                  <br />
                  {text2}
                </>
              )
            : null}
        </div>
      </div>
    // </div>
    );
  }

  return (
    <div className={classNames(
      'w-full p-2 font-bold text-center text-white border-t-2',
      {
        'bg-pxBanner': !purple,
        'bg-pxBannerAlt': purple,
      },
    )}
    >
      {text}
      {(text2)
        ? ` - ${text2}`
        : null}
    </div>
  );
};

Banner.propTypes = {
  text: PropTypes.string.isRequired,
  text2: PropTypes.string,
  corner: PropTypes.bool,
  purple: PropTypes.bool,
};

export default Banner;
